import { withTranslation } from "react-i18next";
import React from 'react';
import { OverlayTrigger } from "react-bootstrap";
import { FiDelete, FiLink2 } from "react-icons/fi";
import Utils from "../../../core/utilities/Utils";
import useHasPermission from "../../../core/hooks/useHasPermission";

const DataSourceLinker = ({ t, item, openDataSourceLink, unlinkDataSource, disabled = false }) => {
	const { hasConfigUpdatePermission } = useHasPermission();

	return (
		<>
			<OverlayTrigger
				placement="top"
				overlay={Utils.renderTooltip(
					item.riskDataSource
						? t("Parameterlinked.label") + " " + item.riskDataSource.name
						: t("Nodatasourcelinked.label")
				)}>
				<li>
					{item.riskDataSource
						? t("Datasourcelinked.label")
						: t("Nodatasourcelinked.label")}
					<a className={`ms-2 ${disabled ? 'disabled-icon' : ''}`} href="#" hidden={!hasConfigUpdatePermission() || disabled}
						onClick={(e) => {
							if (disabled) {
								e.preventDefault();
								return;
							}
							openDataSourceLink(item.id, item.riskDataSource?.id);
						}}>
						<FiLink2 />
					</a>
				</li>

			</OverlayTrigger>
			{
				item.riskDataSource &&
				<OverlayTrigger
					placement="top"
					overlay={Utils.renderTooltip(
						t("Unlinkdatasource.label")
					)}>
					<li className="px-2">
						<a className={`ms-2 cursor ${disabled ? 'disabled-icon' : ''}`} href="#" hidden={!hasConfigUpdatePermission() || disabled}
							onClick={(e) => {
								if (disabled) {
									e.preventDefault();
									return;
								}
								unlinkDataSource(item);
							}}>
							<FiDelete />
						</a>
					</li>
				</OverlayTrigger>
			}
		</>
	);
}

export default withTranslation()(DataSourceLinker);
